/*
  Entry point for tables.php - show league tables
*/
import $ from 'jquery';

$(function () {
  const seasonId = $('select[name="seasonId"]').val();
  getTables(seasonId);

  // change season
  $('select[name="seasonId"]').on('change', function (e) {
    const seasonId = $('select[name="seasonId"]').val();
    getTables(seasonId);
  });
});

/**
 *
 * @param {*} seasonId
 */
function getTables (seasonId) {
  const now = new Date();
  const params = { 'k': now.valueOf(), 'seasonId': seasonId };

  $.get('database/getTables.php', params, 'json')
    .done(function (response) {
      const $tabPanes = $('#tables div.tab-content');
      const $tabs = $('#tables ul.nav-tabs');

      if (response && Object.prototype.hasOwnProperty.call(response, 'count') && response.count > 0) {
        if (response.count === -1) {
          $tabPanes.html(`<div class="alert alert-warning" role="alert">
            Error retrieving results, please try later
          </div>`);
          return false;
        }

        // clear in case we had placed a warning message
        $tabs.empty();
        $tabPanes.empty();

        $.each(response.divs, function (k, d) {
          const name = `${d.event} ${d.division}`;
          const code = `${d.event}-${d.division}`;
          console.log('Adding division: ' + name);

          // create a tab for each division
          const tab = `<li class="nav-item">
            <a class="nav-link" href="#${code}" aria-controls="${code}" role="tab" data-bs-toggle="tab">${name}</a>
          </li>`;
          $tabs.append(tab);

          // create a tabpanel for each division
          const table = `<div role="tabpanel" class="tab-pane" id="${code}">
            <table class="table table-striped">
              <thead>
                <tr><th>Team</th><th>Played</th><th>Points</th>
              </thead>
              <tbody></tbody>
            </table>
            </div>`;
          $tabPanes.append(table);

          const $target = $(`#${code} table`);

          // let ptsTotal = 0;
          // let playedTotal = 0;

          /*
          $.each(d.home, function (j, team) {
            if (d.away[j]) {
              ptsTotal = parseFloat(team.homePts) + parseFloat(div.away[j].awayPts);
              playedTotal = parseInt(team.played) + parseInt(div.away[j].played);
            } else {
              ptsTotal = parseFloat(team.homePts);
              playedTotal = parseInt(team.played);
            }
            const row = `<tr>
              <td>${team.homeTeam}</td>
              <td class="text-end">${playedTotal}</td>
              <td class="text-end">${ptsTotal}</td>
            </tr>`;
            $(`#tables #${name} tbody`).append(row);
          });
          */

          // add a row for each team
          $.each(d.standings, function (j, team) {
            console.log('adding ' + team.team);
            const h = `<tr>
              <td>${team.team}</td>
              <td class="text-end">${team.played}</td>
              <td class="text-end">${team.pts}</td>
            </tr>`;
            $target.find('tbody').append(h);
          });
        });
        // all the tabs now populated so switch to the last one
        $('#tables a:last').tab('show'); // Select last tab
      } else {
        $('#tables div.tab-content').html(`<div class="alert alert-warning" role="alert">
          No league tables available for this season
        </div>`);
      }
    })
    .fail(function (e) {
      console.error(e);
    });
}
